import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Bundle } from './components/Bundle';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    // Small delay to ensure the pixel script is loaded before firing PageView.
    const timer = setTimeout(() => {
      trackPageView();
    }, 0);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-sand/30 selection:text-ink" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Solution data-id="element-6" />
        <Bundle data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FAQ data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}